import { useIntl } from '@capsicum/common';

export const useNCWSendChzAlert = () => {
	const { $t } = useIntl();
	const alertTitle = $t('ncWallet.send.enterAmount.infoTitle');
	const alertSubtitle = $t('ncWallet.send.enterAmount.chzAlert');

	return {
		intlText: {
			alertSubtitle,
			alertTitle
		}
	};
};
